// src/components/BusinessCardFlow/components/LandingPage.js
import React from 'react';
import MyteLogo from '../assets/myte-logo.png';

export default function LandingPage({ startProcess }) {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2rem'
  };
  const logoStyle = {
    width: '150px',
    marginBottom: '1.5rem'
  };
  const headingStyle = {
    fontSize: '1.75rem',
    fontWeight: 'bold',
    marginBottom: '1rem'
  };
  const paragraphStyle = {
    maxWidth: '400px',
    marginBottom: '1.5rem',
    lineHeight: '1.5',
    fontSize: '1rem'
  };
  const buttonStyle = {
    padding: '0.75rem 2rem',
    backgroundColor: '#1F5683',
    borderRadius: '9999px',
    fontSize: '1rem',
    color: '#fff',
    cursor: 'pointer',
    border: 'none'
  };

  return (
    <div style={containerStyle}>
      <img src={MyteLogo} alt="Myte Logo" style={logoStyle} />
      <h1 style={headingStyle}>Business Card to Excel</h1>
      <p style={paragraphStyle}>
        Quickly capture your business cards. Take photos or upload images,
        and instantly convert them to an organized Excel file.
      </p>
      <button onClick={startProcess} style={buttonStyle}>
        Get Started
      </button>
    </div>
  );
}
